import {
  GetAssignmentsForAssigneeRequest,
  GetAssignmentsForAssigneeResponse,
} from '@eigtech/assignments-types'
import { Corn, isCorn } from '@eigtech/shared-corn'
import {
  contextualGet,
  queryOptions,
  useQueries,
  useQuery,
  useQueryClient,
} from '@eigtech/ui-shared-api'
import { assignmentsBasePath, assignmentsQueryKeys } from './constants'

export const getAssignmentsForAssignee = ({ assigneeId }: GetAssignmentsForAssigneeRequest) =>
  contextualGet<GetAssignmentsForAssigneeResponse>(
    `${assignmentsBasePath}/assignable/${assigneeId}`
  )

export const getAssignmentsForAssigneeQueryOptions = (entityId: Corn) =>
  queryOptions({
    queryKey: assignmentsQueryKeys.assignee.assignments(entityId),
    queryFn: () => getAssignmentsForAssignee({ assigneeId: entityId }),
    enabled: !!entityId && isCorn(entityId),
  })

export const useGetAssignmentsForAssignee = (entityId: Corn) =>
  useQuery(getAssignmentsForAssigneeQueryOptions(entityId))

export const useGetAssignmentsForAssignees = (entityIds: Corn[]) =>
  useQueries({
    queries: entityIds.map((id) => getAssignmentsForAssigneeQueryOptions(id)),
  })

export function useInvalidateAssignmentsForAssignee() {
  const queryClient = useQueryClient()

  return function invalidateAssignmentsForAssignee(entityId: Corn) {
    queryClient.invalidateQueries({
      queryKey: getAssignmentsForAssigneeQueryOptions(entityId).queryKey,
    })
  }
}
